export const UNDO_RESUME = 'UNDO_RESUME';
export const SAVE_RESUME = 'SAVE_RESUME';

export const UPDATE_NAME = 'UPDATE_NAME';
export const UPDATE_LASTNAME = 'UPDATE_LASTNAME';
export const UPDATE_JOBTITLE = 'UPDATE_JOBTITLE';
export const UPDATE_PHOTO = 'UPDATE_PHOTO';
export const UPDATE_DETAIL_TITLE = 'UPDATE_DETAIL_TITLE';
export const UPDATE_DETAIL_DESCRIPTION = 'UPDATE_DETAIL_DESCRIPTION';

export const ADD_SECTION = 'ADD_SECTION';
export const REMOVE_SECTION = 'REMOVE_SECTION';
export const SORT_SECTIONS = 'SORT_SECTIONS';
export const UPDATE_SECTION_TITLE = 'UPDATE_SECTION_TITLE';

export const ADD_SECTION_BLOCK = 'ADD_SECTION_BLOCK';
export const UPDATE_SECTION_BLOCK = 'UPDATE_SECTION_BLOCK';
export const SORT_SECTION_BLOCKS = 'SORT_SECTION_BLOCKS';
export const REMOVE_SECTION_BLOCK = 'REMOVE_SECTION_BLOCK';

export const UP_ITEM = 'UP_ITEM';
export const DOWN_ITEM = 'DOWN_ITEM';

export const TOGGLE_EDIT = 'TOGGLE_EDIT';
export const CANCEL_EDIT = 'CANCEL_EDIT';
export const SAVE_LAST_RESUME_EDIT = 'SAVE_LAST_RESUME_EDIT';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js